import { render, staticRenderFns } from "./createWorkTalentDetail.vue?vue&type=template&id=28fb7364&scoped=true"
import script from "./createWorkTalentDetail.vue?vue&type=script&lang=js"
export * from "./createWorkTalentDetail.vue?vue&type=script&lang=js"
import style0 from "./createWorkTalentDetail.vue?vue&type=style&index=0&id=28fb7364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb7364",
  null
  
)

export default component.exports